import { gql } from "@apollo/client";
export const Unfollow = gql `
  mutation Unfollow($input: UnfollowRequest!) {
    unfollow(input: $input) {
      success
    }
  }
`;
export const Follow = gql `
  mutation Follow($input: FollowRequest!) {
    follow(input: $input) {
      success
    }
  }
`;
export const JoinWaitList = gql `
  mutation JoinWaitList($input: JoinWaitListRequest!) {
    joinWaitList(input: $input) {
      success
      position
      referralCode
      referralLink
    }
  }
`;
export const ActivateFromWaitList = gql `
  mutation ActivateFromWaitList($input: ActivateFromWaitListRequest!) {
    activateFromWaitList(input: $input) {
      success
    }
  }
`;
export const RegisterDeviceToken = gql `
  mutation RegisterDeviceToken($input: RegisterDeviceTokenRequest!) {
    registerDeviceToken(input: $input) {
      success
      deviceTokenId
    }
  }
`;
export const UnregisterDeviceToken = gql `
  mutation UnregisterDeviceToken($input: UnregisterDeviceTokenRequest!) {
    unregisterDeviceToken(input: $input) {
      success
    }
  }
`;
export const UpdateNotificationPreferences = gql `
  mutation UpdateNotificationPreferences($input: UpdateNotificationPreferencesInput!) {
    updateNotificationPreferences(input: $input) {
      marketingConsent
      quietHoursEnabled
      quietHoursStart
      quietHoursEnd
      quietHoursTimezone
      categories
    }
  }
`;
export const UpdateAlertRule = gql `
  mutation UpdateAlertRule($input: UpdateAlertRuleInput!) {
    updateAlertRule(input: $input) {
      id
      enabled
      cooldownHours
      alertType
      targetType
    }
  }
`;
export const CancelPolymarketOrderMutation = gql `
  mutation CancelPolymarketOrder($input: CancelPolymarketOrderRequest!) {
    cancelPolymarketOrder(input: $input) {
      success
      orderId
    }
  }
`;
